export const SET_SELECTED_TECH_BUSINESS = 'SET_SELECTED_TECH_BUSINESS'
export const SET_SELECTED_TECHNICIAN = 'SET_SELECTED_TECHNICIAN'
export const SET_TECH_BUSINESS = 'SET_TECH_BUSINESS'
export const SET_TECH_BUSINESSES = 'SET_TECH_BUSINESSES'



// WEBPACK FOOTER //
// ./src/store/modules/admin/config-settings/types.js